import React from 'react'

import PreferencesPanel from '../../../../../core/gd-app/panels/preferences-panel/preferences-panel'
import RightPanelFoldableSection from "../../../../../core/gd-app/panels/common/foldable-section/foldable-section"
import SettingsToggle from "../../../../../core/gd-app/panels/preferences-panel/settings-toggle/settings-toggle"
import page_toggleFullWidth from "../../actions/page-toggle-full-width"
import page_toggleShowControls from "../../actions/page-toggle-show-controls"

type Props = {
    app: any
}

export default class PagePreferences extends React.Component<Props> {

    constructor(props:Props) {
        super(props)
    }

    onFullWidthChange = (value:boolean) => {
        page_toggleFullWidth(value)
    }

    onShowControlsChange = (value:boolean) => {
        page_toggleShowControls(value)
    }

    render() {
        return (
            <PreferencesPanel>
                <RightPanelFoldableSection title="Display settings" description="Page display settings" isOpen={false}>
                    <SettingsToggle size        = "20"
                                    title       = "Full width"
                                    value       = {this.props.app.settings.isFullWidth}
                                    onChange    = {this.onFullWidthChange}/>
                    <SettingsToggle size        = "20"
                                    title       = "Show controls"
                                    value       = {this.props.app.editorLocalSettings.showControls}
                                    onChange    = {this.onShowControlsChange}/>
                </RightPanelFoldableSection>
            </PreferencesPanel>
        )
    }
}